<template>
  <div>
    <div class="all-content-table">
    	<ul>
    		<li v-for="(item,index) in list" :key="index" @click="todetail(item)">
    			<a href="javascript:;">
    				<img v-lazy="item.image" class="all-cover">
    				<div class="all-contentli">
    					<div class="all-contentli-title">{{item.name}}</div>
    					<div class="all-contentli-number">
    						<div class="all-contentli-left"><img src="../../../assets/img/icon-eye.png"><span class="all-contentli-left-text">{{item.watch}}</span></div>
    						<div class="all-contentli-right"><img :src="item.isLike == 0 ? imgurl0 : imgurl1"><span class="all-contentli-left-text">{{item.like}}</span></div>
    					</div>
    				</div>
    			</a>
    		</li>
      </ul>
    </div>
    <div style="text-align: center;" v-show="listlength">
      <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </div>
    <nothing v-show="list.length == 0" :top="`50px`"></nothing>
  </div>
</template>

<script>
  import store from '../../../vuex/store.js'
import {setCookie} from '../../../untils/common.js'
import nothing from '../../../common/nothing.vue'
export default {
  props: {
    list: {
      type: Array,
      default : []
    },
    total: {
      type: Number,
      default : 20
    },
    frompage :{
      type : String,
      default : ''
    }
  },
  data: function () {
    return {
      param : {},
      currentPage3 : 1,
      pageSize : 20,
      imgurl0 : require('../../../assets/img/icon-heart.png'),
      imgurl1 : require('../../../assets/img/icon-heart1.png')
    }
  },
  store,
  components: {nothing},
  computed: {
    listlength() {
      return this.$props.list.length > 0
    }
  },
  methods:{
    handleCurrentChange(index){
      this.$emit('pagechange',index)
    },
    todetail(item){
      if(!this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      setCookie('frompage',this.$props.frompage);

      // 课程详情
      this.$router.push({
          path : 'BookCourseDetail',
          query : {id : item.id},
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BookCourse/child/courseList.vue